import React from 'react';
import ABSRows from './ABSRows';
import ABSNews, { INewsList } from './ABSNews';

export interface IABSListRowsContainerProps {
  className?: string;
  actionType: string;
  title: string;
  payload: Object;
  model: string;

  comment?: any;
  loading?: boolean;
  list?: any[];
  renderRow?: (item: any) => any;
  renderRightContent?: (item: any, key?: number) => any;
  dispatch?: any;

  newsList?: INewsList;
  isRows?: boolean;
}

class ABSListRowsContainer extends React.Component<IABSListRowsContainerProps, any> {

  render() {
    const { isRows } = this.props;
    if (isRows) {
      return <ABSRows {...this.props} />;
    }
    return <ABSNews {...this.props} />;
  }
}

export default ABSListRowsContainer;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSListRowsContainer/index.tsx